import React from 'react';
import MonthlyTurnoverCard from '../Common/MonthlyTurnover';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
const questionConfig = getQuestionConfig(ProfilerQuestionID.FMCG_TURNOVER);

const MonthlyTurnover = (props) => {
  return (
    <MonthlyTurnoverCard
      industryType='Fmcg'
      questionId={ProfilerQuestionID.FMCG_TURNOVER}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      {...props}
    />
  );
};

export default MonthlyTurnover;
